










































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ChooseSubjectVue from "@/components/ChooseSubject.vue";
import version from "@/version";


@Component({
	...mapGetters(["accountBook"]),
	components: {
		"choose-subject": ChooseSubjectVue,
		"month-selector": MonthSelectorVue,
	},
})
export default class InventoryBalance extends Vue {
	subjectList: Subject.Subject[] = [];
	dimInventoryList: Assist.AssistAccount[] = [];
	subjectVal: Subject.Subject | null = null;
	dimVal: Assist.AssistAccount | null = null;
	dataList: any[] = [];
	period: string[] = [];

	downLoad() {
		let id = "";
		let dimId = ""
		if (this.subjectVal && this.subjectVal.id) id = this.subjectVal.id.toString()
		if (this.dimVal && this.dimVal.id) dimId = this.dimVal.id.toString()
		if (this.subjectVal && this.dimVal) {
			let url = `${Vue.axios.defaults.baseURL}export/inventory/order/balance?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&subjectId=${id}&version=${version}&dimAccountId=${dimId}&token=${this.$store.state.account.token}`;
			this.$store.dispatch("toggleDownload", true);
			this.$utils.sendToElectron("download", url);
		}
	}

	async changeDate(period: string[]) {
		this.period = period;
		await this.fetchList();
		this.fetchData();
	}

	async fetchList() {
		if (
			this.subjectList.length === 0 &&
			this.dimInventoryList.length === 0
		) {
			const res = await Vue.axios.get(
				`inventory/order/preset?accountBookId=${this.$store.state.accountBook.id}`
			);
			this.subjectList = res.data.data.subjectList;
			res.data.data.dimInventoryList.unshift({
				id: null,
				no: "",
				name: "全部",
			});
			this.dimInventoryList = res.data.data.dimInventoryList;
		}
	}

	async fetchData() {
		if (
			this.subjectVal &&
			this.dimVal &&
			this.subjectVal !== null &&
			this.dimVal !== null
		) {
			const relation: {
				subjectId?: number | null;
				dimInventoryId?: number | null;
			} = {
				subjectId: this.subjectVal.id,
			};
			if (this.dimVal.id !== null)
				relation.dimInventoryId = this.dimVal.id;
			const res = await Vue.axios.post("balances/find/inventory", {
				accountBookId: this.$store.state.accountBook.id,
				startPeriod: this.period[0],
				endPeriod: this.period[1],
				subjectId: this.subjectVal.id,
				dimInventoryId: this.dimVal.id,
			});
			this.dataList = res.data.balances;
		}
	}

	// 打开凭证
	dialogVoucher: boolean = false;
	openVoucher(data: any) {
		if (data.voucherId != -1) {
			this.dialogVoucher = true;
			this.$nextTick(() => {
				let comVoucher: any = this.$refs.voucher;
				comVoucher.isDialog = true;
				comVoucher.isEdit = true;
				comVoucher.shouldGetInit = false;
				comVoucher.showSaveAndAdd = false;
				comVoucher.showAdd = false;
				comVoucher.getSubjectList(
					data.date.replace(/-/, "").substring(0, 6),
					() => {
						Vue.axios
							.post(`voucher/` + data.voucherId + `/find`, {
								id: 123,
							})
							.then((res) => {
								comVoucher.packVoucher(res.data);
								comVoucher.isEdit = true;
								comVoucher.showSaveAndAdd = false;
								comVoucher.showAdd = false;
							});
					}
				);
			});
		}
	}

	syncScroll() {
		const tbody = this.$el.querySelector(".data-table")!;
		this.$el.querySelectorAll(".col-fixed")!.forEach(td => {
            (<HTMLElement>td).style.transform = `translateX(${tbody.scrollLeft}px)`;
        });
	}
}
